import React from 'react';
import styles from '../../stylesheets/tenantLayout.module.scss';

interface TenantLayoutProps {
  children: React.ReactNode;
}

const TenantLayout = ({ children }: TenantLayoutProps) => {
  return (
    <div className={styles.tenantLayout}>
      <header className={styles.header}>
        <h1 className={styles.title}>Tenant Preview</h1>
        <h2 className={styles.subtitle}>Simulated Environment</h2>
      </header>
      <div className={styles.content}>
        <main>{children}</main>
      </div>
    </div>
  );
};

export default TenantLayout;
